import { PDFDocument } from 'pdf-lib';

const inchesToPoints = (inches: number) => inches * 72;

const base64ToUint8Array = (base64: string) => {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const uint8ArrayToBase64 = (bytes: Uint8Array) => {
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...Array.from(chunk));
  }
  return btoa(binary);
};

export async function pngBase64ToPdfBase64(
  pngBase64: string,
  size: { widthIn: number; heightIn: number }
): Promise<string> {
  const pdf = await PDFDocument.create();
  const page = pdf.addPage([
    inchesToPoints(size.widthIn),
    inchesToPoints(size.heightIn)
  ]);

  const pngBytes = base64ToUint8Array(pngBase64);
  const png = await pdf.embedPng(pngBytes);

  page.drawImage(png, {
    x: 0,
    y: 0,
    width: page.getWidth(),
    height: page.getHeight()
  });

  const pdfBytes = await pdf.save();
  return uint8ArrayToBase64(pdfBytes);
}
